import React, { Fragment } from "react";
/* -- LAYOUT OBJECTS - */
import Main from "./main";
import Container from "./container";
import Content from "./content";
import Header from "./header";
import Footer from "./footer";
import MainDisplay from "./content/components/main-display";
/* -- LAYOUT OBJECTS - */
import UiKit from "../../common/uikit";

const Layout = (props) => {
  const p = props;
  return (
    <Fragment>
      <Main>
        <Container>
          <Header />
          <Content>
            <MainDisplay>
              <div className="content-page-container">{p.children}</div>
            </MainDisplay>
          </Content>
          <Footer />
        </Container>
      </Main>
      <UiKit.Toast />
    </Fragment>
  );
};

export default Layout;
